import { apiClient, handleResp } from './utils';

export default {
  getVideoToReview() {
    return handleResp(apiClient().get('/intro_videos/get_video_to_review'));
  },
  doUpdateVideo(videoId, data) {
    return handleResp(apiClient().put('/intro_videos/' + videoId, data));
  },
};
